import { render, staticRenderFns } from "./bg-title.vue?vue&type=template&id=432fc981&"
import script from "./bg-title.vue?vue&type=script&lang=js&"
export * from "./bg-title.vue?vue&type=script&lang=js&"
import style0 from "./bg-title.vue?vue&type=style&index=0&id=432fc981&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports